export enum PersonalInfoState{
  StudentInfoPending,
  ParentsInfoPending,
  Completed
}

export const PersonalInfoStateDescriptions: { [key in PersonalInfoState]: string } = {
  [PersonalInfoState.StudentInfoPending]: "Student Info Pending",
  [PersonalInfoState.ParentsInfoPending]: "Parents Info Pending",
  [PersonalInfoState.Completed]: "Completed"
}
